var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 10 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 14.5833H35.4166C37.7178 14.5833 39.5833 16.4488 39.5833 18.75V19.7917C39.5833 20.367 40.0496 20.8333 40.6249 20.8333C41.2002 20.8333 41.6666 21.2997 41.6666 21.875V28.125C41.6666 28.7003 41.2002 29.1667 40.6249 29.1667C40.0496 29.1667 39.5833 29.633 39.5833 30.2083V31.25C39.5833 33.5512 37.7178 35.4167 35.4166 35.4167H12.4999C10.1987 35.4167 8.33325 33.5512 8.33325 31.25V18.75C8.33325 16.4488 10.1987 14.5833 12.4999 14.5833",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 14.5833H35.4166C37.7178 14.5833 39.5833 16.4488 39.5833 18.75V19.7917C39.5833 20.367 40.0496 20.8333 40.6249 20.8333C41.2002 20.8333 41.6666 21.2997 41.6666 21.875V28.125C41.6666 28.7003 41.2002 29.1667 40.6249 29.1667C40.0496 29.1667 39.5833 29.633 39.5833 30.2083V31.25C39.5833 33.5512 37.7178 35.4167 35.4166 35.4167H12.4999C10.1987 35.4167 8.33325 33.5512 8.33325 31.25V18.75C8.33325 16.4488 10.1987 14.5833 12.4999 14.5833",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 20.8333V29.1667",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 20.8333V29.1667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 20.8333V29.1667",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8334 20.8333V29.1667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0834 20.8333V29.1667",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0834 20.8333V29.1667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 20.8333V29.1667",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 20.8333V29.1667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.bf886eb804a43575ca7fdad6c12cde47.svg";
export { ForwardRef as ReactComponent };